<template>
    <div class="page" id="page_experience">
        <header>
            <h2>Experience as a Company, Perform as an Entity</h2>
            <figure class="mobile-hide"><img src="images/experience-title-bg.jpg" alt="Team" width="900" height="607" /></figure>
        </header>
        <div class="content-container"> 
        <div class="rowTop ">
            <div class="item">
                <img src="images/experience-lack-of-interaction.png" alt="Team" width="114" height="112" />
                <b>Lack of interaction</b> and <b>networking</b> among a group of employees is one of the biggest concerns that organizations have.
            </div>
            <figure class="divider  ">
                <img src="images/experience-props1.png" alt="Props" width="67" height="112" />
            </figure>
            <div class="item">
                <img src="images/experience-interaction.png" alt="Team" width="79" height="112" />
                Enabling and improving <b>interaction</b> and <b>networking</b> among employees can help the company to grow significantly.
            </div>
            <figure class="divider"><img src="images/experience-props2.png" alt="Props" width="20" height="112" /></figure>
            <div class="item">
                <img src="images/experience-events.png" alt="Team" width="160" height="112" />
                <b>Incentive trips</b> prove to be one of the most desired options - under a relaxed and holiday setting; employees are likely to be more <b>interactive</b> and <b>sociable</b>.
            </div>
        </div>
        
        <figure class="mobile-hide"><img src="images/experience-team.jpg" alt="Team" width="900" height="790" /></figure>

        <div class="rowBottom">
            <div id="experienceTeamBuilding" class="box" data-aos="fade-up">
                <figure><img src="images/experience-team-building.png" alt="Team Building Image" width="240" height="84" /></figure>
                <h3>Team Buidling</h3>
                <ul>
                    <li>Allows maximum interaction</li>
                    <li>Fosters stronger bonds among co-workers</li>
                    <li>Improves teamwork and thus productivity</li>
                    <li>Improves problem-solving skills</li>
                    <li>Allows employees to understand and appreciate peers' working styles.</li>
                </ul>								
            </div>
            <div id="experienceSocialNight" class="box " data-aos="fade-up">
                <figure><img src="images/experience-social-nights.png" alt="Social Nights Image" width="240" height="84" /></figure>
                <h3>Social Night</h3>
                <ul>
                    <li>Gives recognition to the employees by means of 
    award presentation</li>
                    <li>Creates a sense of belonging to the company</li>
                    <li>Shows appreciation for employees' loyalty</li>
                    <li>Allows interaction and networking across the entire organization</li>
                    <li>Provides platform for management to gather ideas and feedback</li>
                </ul>
            </div>	
            <div id="experienceExcursion" class="box" data-aos="fade-up">
                <figure><img src="images/experience-excursion.png" alt="Excursion Image" width="240" height="84" /></figure>
                <h3>Excursion</h3>
                <ul>
                    <li>A form of reward that will be valuable and long lasting in the minds of the employees</li>
                    <li>Creates memorable moments spent together as a company</li>
                    <li>Allows interaction and networking across the organization</li>
                    <li>Provides platform for management to gather ideas and feedback</li>
                    <li>Motivates employees to produce better results for the next trip</li>
                </ul>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Experience'
}
</script>

<style lang="less" scoped>
#page_experience {
    background: #4c4c4c;
    

    header {
        color: @lightColor;
        background: #000;
        //margin-bottom: 0;
    }

    .divider {
        display: none;
    }

    .rowTop {
        color: @lightColor;
        display: flex;
        flex-direction: column;
        justify-content: center;

        .item {
            margin: 60px 0; 
            text-align: center;
        }
        .item img {
            display: block;
            margin: 0 auto 20px;
            width: auto;
        }

    }

    .box {
        .boxPadding;

        background: @lightColor;
        border: 5px solid #e3b317;
        margin: 60px 10px;
        outline: 5px solid @lightColor;

        h3 {
            text-align: center;
        }

        figure {
            margin: 15px auto 5px;
            width: 50%;
        }

        ul {
            padding: 0 0 0 25px;
        }
        li {
            list-style-image: url(../../public/images/bullet.png);
            padding: 0 0 0 5px;
        }
    }
}
@media only screen and (min-width : 768px) {
    #page_experience {
        h2 {
            text-align: center;
        }
        .rowTop {
            display: flex;
            flex-direction: row;

            .divider {
                display: block;

                img {
                    margin-top: 60px;
                    width: auto;
                    //height: initial;
                }
            }

            .item {
                width: 28%;
            }
        }
        .rowBottom {
            margin: 60px 0;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
        }
        .box {
            margin: 0 2.5% 40px;
            padding: 10px;
            width: 45%;

            &:last-child {
                margin: 0 auto 40px;
            }
        }
    }
}
@media only screen and (min-width : 1118px) {
     #page_experience {
        .box {
            margin: 0 3% 40px;
            padding: 10px;
            width: 27%;

            
        }
     }
}
</style>